module.exports = __webpack_public_path__ + "img/group.5753f015.svg";